export enum QuoteStatus {
  Submitted = 'Submitted',
  Approved = 'Approved',
}
